import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 30000 });

export const fetchQuestions = async () => {
  const res = await api.get("/questions");
  return res.data.questions;
};

export const subscribe = (email, answers) =>
  api.post("/subscribe", { email, answers });

export const getPreferences = (token) =>
  api.get(`/manage/${token}`);

export const savePreferences = (token, answers) =>
  api.put(`/manage/${token}`, { answers });

export const unsubscribe = (token) =>
  api.post(`/unsubscribe/${token}`);

export const resubscribe = (token) =>
  api.post(`/resubscribe/${token}`);

export const confirmSubscription = (token) =>
  api.post(`/confirm/${token}`);
